import { useTranslation } from 'next-i18next/pages';
import React from 'react';

import { useMediaQuery } from '@/hooks/shared/useMediaQuery';

import Area from '@/components/apps/layouts/shared/Area';
import SectionTitle from '@/components/apps/ui/title/SectionTitle';

import theme from '@/styles/theme';

import SolutionItem from './SolutionItem';
import {
  getEdgeArchitectureItem,
  getOnPremArchitectureItem,
} from './solutionArchitectureData';

type SolutionArchitectureSectionProps = {
  variant: 'edge' | 'onprem';
  idPrefix: string;
};

/**
 * ### SolutionArchitectureSection
 *
 * 기존 `/technology` 작동 방식 중 하나의 구성 방식만 보여주는 이식 섹션.
 * Safety 에는 엣지 분석서버 방식, Industrial 에는 온프렘 방식을 배치한다.
 * 내부 원시 컴포넌트가 라이트 테마 전제라 섹션 자체를 라이트 밴드로 감싸
 * 다크 페이지에서도 그대로 렌더링한다.
 */
export default function SolutionArchitectureSection({
  variant,
  idPrefix,
}: SolutionArchitectureSectionProps) {
  const { t } = useTranslation('common');
  const isDesktop = useMediaQuery({
    query: `(min-width: ${theme`screens.lg`})`,
  });
  const item =
    variant === 'edge'
      ? getEdgeArchitectureItem(t)
      : getOnPremArchitectureItem(t);

  return (
    <section
      className="bg-apps-coreGrayWhite py-[100px] text-apps-coreGray01 lg:py-[clamp(100px,16.667vw,200px)]"
      data-analytics-section="solution_architecture"
    >
      <Area>
        <div className="grid gap-10 lg:gap-[clamp(40px,6.667vw,80px)]">
          <SectionTitle title={t('솔루션 작동 방식')} />
          <SolutionItem
            {...item}
            isDesktop={isDesktop}
            index={0}
            idPrefix={idPrefix}
          />
        </div>
      </Area>
    </section>
  );
}
